import React from "react"
import propTypes from "prop-types"
import { connect } from "react-redux"
import "./styles.scss"
import { NavLink } from "react-router-dom"
import configs from "../../configs"

import Logo from "../Logo"

class Footer extends React.Component {
  getNavLink = (href, title, dependent) => {
    const {
      store: { user }
    } = this.props

    let guardian = false

    if (user.list_role) {
      guardian = user.list_role.includes(configs.roles.Guardian)
    }

    if (dependent && dependent === "userIsGuardian" && guardian) {
      return null
    }
    return (
      <NavLink exact to={href} activeClassName="footer_nav--active">
        {title}
      </NavLink>
    )
  }

  render() {
    return (
      <footer className="footer">
        <div className="container">
          <div className="row">
            <div className="col-xl-5 offset-xl-1">
              <Logo color="white" href="/" title="Resanec" />
              <div className="footer_description">
                NDIS Pre-Planning
                <br />
                Online is easy. When done together, it’s better.
              </div>
            </div>
            {configs.footer_navigation.map(({ col, colId }) => (
              <div key={colId} className="col-md">
                <ul className="footer_nav">
                  {col.map(({ href, title, external, id, dependent }) => (
                    <li key={id}>
                      {external ? (
                        <a href={href}>{title}</a>
                      ) : (
                        this.getNavLink(href, title, dependent)
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </footer>
    )
  }
}

Footer.propTypes = {
  store: propTypes.shape({
    user: propTypes.shape({
      list_role: propTypes.arrayOf(propTypes.number)
    }).isRequired
  }).isRequired
}

const mapStateToProps = ({ AuthenticationReducer }) => ({
  store: {
    user: AuthenticationReducer.user
  }
})

export default connect(mapStateToProps)(Footer)
